<template>
	<div>
		<section class="mainsection">
			<div class="container" style="margin-top:20px;">
				<div class="row">
					<div class="col-sm-pull-12 col-md-12">
						<div class="row justify-content-center">
							<div class="col-lg-12">
								<card
									type="secondary"
									shadow
									header-classes="bg-white pb-5"
									class="border-0"
								>
									<div class="row">
										<div class="col-lg-12 my-1">
											<div class="btn-wrapper float-left">
												<base-button
													tag="a"
													class="mb-3 mb-sm-0"
													type="info"
													textColor="black"
													icon="fa fa-arrow-left"
													@click="goback()"
													>Kembali</base-button
												>
												<br />
												<br />
											</div>
										</div>
									</div>
									<template>
										<h6
											slot="header"
											class="modal-title text-success font-weight-bold"
											id="modal-title-default"
										>
											Pelaporan Pajak BPHTB
										</h6>
										<div class="d-block" v-if="checkAkses">
											<div class="alert alert-default">
												<strong>Informasi!</strong> :
												<ul>
													<li>
														Unduh template permohonan pelaporan pajak di link
														ini
													</li>
													<li>
														Silahkan pilih Tahun Pelaporan Pajak
													</li>
													<li>
														Pilih Masa Pajak yang ingin dilaporkan
													</li>
													<li>
														Laporkan pajak dengan upload surat permohonan
														pelaporan pajak
													</li>
												</ul>
											</div>
											<ValidationObserver v-slot="{ handleSubmit }">
												<form ref="form" @submit.stop.prevent="handleSubmit()">
													<div
														class="alert alert-danger"
														v-if="error_msg.length > 0"
													>
														<strong>Warning!</strong> Perbaiki hasil input Anda
														:
														<ul>
															<li v-for="text in error_msg" :key="text">
																{{ text }}
															</li>
														</ul>
													</div>
													<div class="mb-5">
														<div class="row mb-2">
															<div class="col-md-12">
																<div class="row">
																	<div class="col-md-4 col-sm-12">
																		<ValidationProvider
																			name="Tahun SPT"
																			rules="required"
																			v-slot="{ errors }"
																		>
																			<label>Tahun Pajak </label>
																			<select
																				class="form-control"
																				name="collection_year"
																				id="collection_year"
																				v-model="form.year"
																				:class="[
																					{ 'is-valid': !errors[0] === true },
																					{
																						'is-invalid': !errors[0] === false,
																					},
																				]"
																				@change="getData"
																			>
																				<option value disabled selected
																					>--- Pilih Tahun ---
																				</option>
																				<option
																					:value="year.value"
																					v-for="year in optionYear"
																					:key="year.value"
																					>{{ year.text }}</option
																				>
																			</select>
																			<div
																				class="text-danger invalid-feedback"
																				style="display: block"
																				v-if="errors[0]"
																			>
																				{{ errors[0] }}
																			</div>
																		</ValidationProvider>
																	</div>
																</div>
															</div>
														</div>

														<div class="row">
															<div class="col-md-12">
																<div class="table-responsive-sm">
																	<table
																		class="table b-table table-hover table-bordered table-sm"
																	>
																		<thead>
																			<tr
																				class="tr-values vs-table--tr tr-table-state-null"
																			>
																				<th>Masa Pajak</th>
																				<th>Tanggal Pelaporan</th>
																				<th>Total Pajak</th>
																				<th>Surat Permohonan</th>
																				<th>Status</th>
																				<th>Aksi</th>
																			</tr>
																		</thead>
																		<tbody>
																			<tr
																				class="tr-values vs-table--tr tr-table-state-null"
																				v-for="(item, index) in data"
																				:key="index"
																			>
																				<th>
																					{{ list_month[item.masa_pajak] }}
																				</th>
																				<td style="text-align: center;">
																					{{
																						formatDate(item.tanggal_pelaporan)
																					}}
																				</td>
																				<td style="text-align: right;">
																					{{
																						item.total_pajak == ""
																							? ""
																							: formatMoney(item.total_pajak)
																					}}
																				</td>
																				<td style="text-align: center;">
																					<a
																						class="btn btn-primary text-white"
																						@click="downloadFile(item.file)"
																						size="small"
																					>
																						{{ item.file }}
																					</a>
																				</td>
																				<td>{{ item.status }}</td>
																				<td>
																					<a
																						@click="goLaporPajak(item)"
																						v-if="item.request_update == 0"
																						class="btn btn-default text-white"
																						>Lapor Pajak</a
																					>

																					<a
																						v-if="item.request_update == 1"
																						@click="requestUpdate(item)"
																						class="btn btn-warning text-white"
																						>Perbaiki</a
																					>
																				</td>
																			</tr>
																		</tbody>
																	</table>
																</div>
															</div>
														</div>
													</div>
												</form>
											</ValidationObserver>
										</div>
										<div class="d-block" v-else>
											<div class="alert alert-default">
												<strong>Informasi!</strong> :
												<ul>
													<li>
														Harap login menggunakan email.
													</li>
													<li>
														Jika belum registrasi menggunakan email silahkan
														registrasi email Anda dan kemudian hubungkan email
														Anda di menu objek pajak -> hubungkan email.
													</li>
												</ul>
											</div>
										</div>
									</template>
								</card>
							</div>
						</div>
					</div>
				</div>
			</div>
			<add-pajak ref="modal-add-pajak" @refresh="getData()"></add-pajak>
		</section>
	</div>
</template>
<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue"
import navBarPelaporan from "./navBarPelaporan.vue"
import AddPajak from "./AddPajak.vue"
import { ValidationProvider, ValidationObserver } from "vee-validate"
import vSelect from "vue-select"
import axios from "axios"
import qs from "qs"
import { formatMoney } from "accounting-js"
import moment from "moment"
import Swal from "sweetalert2"
export default {
	components: {
		PulseLoader,
		ValidationProvider,
		ValidationObserver,
		vSelect,
		navBarPelaporan,
		AddPajak,
	},
	computed: {
		checkAkses() {
			if (this.$store.state.auth.status.loggedIn)
				return this.$store.state.auth.user.is_wajib_pajak
			return false
		},
		optionYear() {
			var i = 0
			var optionsYear = []
			let year = new Date().getFullYear()
			for (i = 2019; i <= year; i++) optionsYear.push({ value: i, text: i })
			return optionsYear
		},
	},
	data() {
		return {
			list_month: {
				1: "Januari",
				2: "Febuary",
				3: "Maret",
				4: "April",
				5: "Mei",
				6: "Juni",
				7: "Juli",
				8: "Agustus",
				9: "September",
				10: "Oktober",
				11: "November",
				12: "Desember",
			},
			data: [],
			form: {
				year: null,
				id: [],
			},
			isBusy: false,
			error_msg: [],
			edit: false,
		}
	},
	methods: {
		downloadFile(name) {
			axios({
				url: "/api/v1/download_pdf?filename=" + name, //your url
				method: "GET",
				responseType: "blob", // important
			}).then((response) => {
				const url = window.URL.createObjectURL(new Blob([response.data]))
				const link = document.createElement("a")
				link.href = url
				link.target = "_blank"
				link.setAttribute("download", name) //or any other extension
				document.body.appendChild(link)
				link.click()
			})
		},
		goLaporPajak(item) {
			this.$refs["modal-add-pajak"].showModal(this.form.year, item.masa_pajak)
		},
		requestUpdate(item) {
			this.$refs["modal-add-pajak"].showModal(
				this.form.year,
				item.masa_pajak,
				item.total_pajak,
				item.file
			)
		},
		formatDate(date) {
			if (date == "" || date == null) return ""
			return moment(date).format("lll")
		},
		formatMoney(val) {
			return formatMoney(val, {
				symbol: "Rp. ",
				precision: 0,
				thousand: ".",
				decimal: ",",
			})
		},
		async getData() {
			const me = this
			try {
				let { data } = await axios.get(
					"/api/v2/pelaporan?year=" + this.form.year
				)
				this.data = []
				var currDate = new Date()
				var currMonth = currDate.getMonth()
				var lastIndex = 12
				if (currDate.getFullYear() == this.form.year) {
					lastIndex = currMonth
				}
				for (let index = 1; index <= lastIndex; index++) {
					let taxes_reporting = data.find((obj) => obj.month == index)
					this.data.push({
						thn_pajak: this.form.year,
						masa_pajak: index,
						tanggal_pelaporan:
							taxes_reporting != null ? taxes_reporting.created_at : "",
						total_pajak:
							taxes_reporting != null ? taxes_reporting.total_tax : "",
						status:
							taxes_reporting != null
								? "Sudah Lapor Pajak"
								: "Belum Lapor Pajak",
						request_update: taxes_reporting != null ? 1 : 0,
						id: taxes_reporting != null ? taxes_reporting.id : 0,
						file: taxes_reporting != null ? taxes_reporting.file : null,
					})
				}
			} catch (error) {
				this.isBusy = false
				me.error_msg = ["Internal Server Error"]
			} finally {
				this.isBusy = false
			}
		},
	},
}
</script>
<style></style>
